import * as betgalaxy from './Maintenance.styles.betgalaxy';
import * as betprofessor from './Maintenance.styles.betprofessor';
import * as betroyale from './Maintenance.styles.betroyale';
import * as fiestabet from './Maintenance.styles.fiestabet';
import * as goldenrush from './Maintenance.styles.goldenrush';
import * as juicybet from './Maintenance.styles.juicybet';
import * as puntcity from './Maintenance.styles.puntcity';
import * as puntgenie from './Maintenance.styles.puntgenie';
import * as questbet from './Maintenance.styles.questbet';
import * as sterlingparker from './Maintenance.styles.sterlingparker';
import * as vikingbet from './Maintenance.styles.vikingbet';
import * as volcanobet from './Maintenance.styles.volcanobet';
import * as wellbet from './Maintenance.styles.wellbet';
import * as junglebet from './Maintenance.styles.junglebet';
import * as oldgill from './Maintenance.styles.oldgill';
import * as sugarcastle from './Maintenance.styles.sugarcastle';
import * as buffalobet from './Maintenance.styles.buffalobet';
import * as titanbet from './Maintenance.styles.titanbet';
import * as bet777 from './Maintenance.styles.bet777';
import * as slambet from './Maintenance.styles.slambet';
import * as gigabet from './Maintenance.styles.gigabet';
import * as betstride from './Maintenance.styles.betstride';
import * as templebet from './Maintenance.styles.templebet';
import * as goldenbet888 from './Maintenance.styles.goldenbet888';
import * as hyperbet from './Maintenance.styles.hyperbet';
import * as chromabet from './Maintenance.styles.chromabet';
import * as bet575 from './Maintenance.styles.bet575';
import * as betblast from './Maintenance.styles.betblast';
import * as pyramidbet from './Maintenance.styles.pyramidbet';
import * as magnumbet from './Maintenance.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  bet777,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
